module.exports = __webpack_public_path__ + "img/Success-3.e2e953c1.png";